import { useMutation } from '@tanstack/react-query';
import type { AssignmentViewModel } from 'api/model';
import useCustomInstance from 'api/mutator/custom-instance';

export const useAssignmentGetUnassignedAssignmentsByAddressProximityHook =
  () => {
    const customInstance = useCustomInstance<AssignmentViewModel[]>();

    // placeholderAssignmentId: listan visar bara bilar som utfyllnadsuppdragets
    // fälttestare har behörighet för (t.ex. automatkort ⇒ inga manuella bilar).
    return (approximateStartTime: Date, placeholderAssignmentId?: number) => {
      return customInstance({
        url: `/api/Assignment/GetUnassignedAssignmentsByAddressProximity`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: { approximateStartTime, placeholderAssignmentId },
      });
    };
  };

export const useAssignmentGetUnassignedAssignmentsByAddressProximity = () => {
  const hook =
    useAssignmentGetUnassignedAssignmentsByAddressProximityHook();

  const mutationFn = (props: { data: Date; placeholderAssignmentId?: number }) =>
    hook(props.data, props.placeholderAssignmentId);

  return useMutation({ mutationFn });
};

export const useGeocodeAssignmentCoordinatesHook = () => {
  const customInstance = useCustomInstance<AssignmentViewModel>();

  return (assignmentId: number) => {
    return customInstance({
      url: `/api/Assignment/GeocodeAssignmentCoordinates`,
      method: 'POST',
      params: { assignmentId },
    });
  };
};
